import { type FC, type ReactNode, useCallback } from "react";

import { SortBy, SortDirection } from "../sort";

import { ClickableHeaderItem, sortIconAsc, sortIconDesc } from "./SortableHeaderItem.style";
import { type OnSort } from "./models";

interface SortableHeaderItem {
    className?: string;
    sortBy: SortBy;
    sortDirection: SortDirection;
    itemSortByKey: SortBy;
    onSort: OnSort;
    children?: ReactNode;
}

const iconsMap: Partial<Record<SortDirection, string>> = {
    [SortDirection.Asc]: sortIconAsc,
    [SortDirection.Desc]: sortIconDesc,
};

export const SortableHeaderItem: FC<SortableHeaderItem> = ({
    className,
    sortBy,
    sortDirection,
    itemSortByKey,
    onSort,
    children,
}) => {
    const icon = iconsMap[sortDirection];
    const handleSortChange = useCallback(() => {
        if (sortBy === itemSortByKey) {
            // flip the direction
            onSort(sortBy, sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc);
        } else {
            const defaultDirection = itemSortByKey === SortBy.Date ? SortDirection.Desc : SortDirection.Asc;
            onSort(itemSortByKey, defaultDirection);
        }
    }, [onSort, sortBy, sortDirection, itemSortByKey]);

    return (
        <ClickableHeaderItem className={className} onClick={handleSortChange}>
            {children}
            {sortBy === itemSortByKey && <span className={icon} />}
        </ClickableHeaderItem>
    );
};
